<div class="assistant-container">
  <h3 class="assistant-header">Welcome to Valuation & Advisory Assistant</h3>
  <p class="assistant-subheader">Try asking the assistant a question. The AI is new so mistakes are possible. Make sure
    to check the facts, and share feedback.</p>


  <div class="chat-interface">
    <!-- ... other chat content ... -->

    <div class="chat-input">
      <input matInput placeholder="Ask a question..." />
      <mat-icon>send</mat-icon>
    </div>
  </div>
</div>